import { compose, pure } from 'recompose';

import ConfirmModal from './confirmModal';

const enhance = compose(
  pure,
);
export default enhance(ConfirmModal);
